// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-share[data-v-0d2dca06]{display:flex;justify-content:center}", ""]);
// Exports
module.exports = exports;
